import login from "./login.json";
import items from "./items.json";
import accounts from "./accounts.json";
import navbar from "./navbar.json";
import searchbar from "./searchbar.json";
import trendingRow from "./trendingRow.json";
import {
  Item,
  LoginData,
  NavbarData,
  SearchBarData,
  TrendingRowData,
} from "../interfaces/interfaces";
import { Account } from "../utils/data";

const data = {
  login: login as unknown as LoginData,
  items: items as unknown as Item[],
  accounts: accounts as unknown as Account[],
  navbar: navbar as unknown as NavbarData,
  searchbar: searchbar as unknown as SearchBarData,
  trendingRow: trendingRow as unknown as TrendingRowData,
};

export default data;
